import { Injectable } from "@angular/core";
/* tslint:disable-next-line:no-unused-variable 
   Type import */
import { Storage } from "@ionic/storage-angular";

import { console } from "#/log";

/**
 * Provides functions for saving and restoring application state data in the
 * internal app.  These values are not saved on firebase.
 */
@Injectable()
export class StateService {
  stack: Array<any> = [];

  constructor(private storage: Storage) {}

  /**
   * Sets the viewed state of tutorial
   */
  setTutorialViewed(isViewed: boolean = true) {
    return this.storage.set("tutorialViewed", isViewed);
  }

  getTutorialViewed() {
    return this.getState("tutorialViewed");
  }

  /**
   * Saves the page constructor name and associated data to be passed using
   * NavParams into the stack property in local storage.
   */
  saveView(
    pageName: any,
    data: { hasOwnProperty: (arg0: string) => any; sample: any; range: any },
  ) {
    // clear out any parameters that may contain function.
    // maybe we should just store a stringified version?
    if (data.hasOwnProperty("sample")) {
      data.sample = JSON.parse(JSON.stringify(data.sample));
    }
    if (data.hasOwnProperty("range")) {
      data.range = JSON.parse(JSON.stringify(data.range));
    }
    this.storage.set("stack", [
      {
        page: pageName,
        params: data,
      },
    ]);
  }

  saveSamples(samples: any, uid: string) {
    this.storage.set("samples-" + uid, samples).catch((e: any) => {
      console.error(e);
    });
  }

  setState(prop: string, value: any) {
    return this.storage.set(prop, value);
  }

  /**
   * Gets a value from local storage based on the property provided.
   */
  getState(prop: string) {
    return this.storage.get(prop);
  }

  getViewStack() {
    return this.getState("stack").then((val: any) => {
      if (val) {
        return val;
      }
      throw Error("no view stack to restore");
    });
  }

  /**
   * Clears all internal state data
   */
  clearState(propertyName: string) {
    return this.storage.remove(propertyName);
  }
}
